import { isString } from 'lodash-es';
import { DEFAULT_NOTIFICATION_TYPES } from '../../../constants';

const makeSuccessNotificationPayload = (data, timeout) => {
  const newData = {};

  if (isString(data)) {
    newData.message = data;
  } else {
    Object.assign(newData, data);
  }

  return {
    ...newData,
    timeout,
    notificationType: DEFAULT_NOTIFICATION_TYPES.SUCCESS
  };
};

export default makeSuccessNotificationPayload;
